import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  lang: string = 'FR'; // Default language
  foot: boolean = true;
  title: string = 'K.A.Z';
  nav: any[] = [];

  nav1: any[] = [
    { lg: 'Accueil', route: '/homefr', liste: [] },
    { lg: 'Services', route: '/services', liste: [] },
    { lg: 'Références', route: '/reference', liste: [] },
    {
      lg: 'Formations',
      action: 'scroll',
      target: 'training-section',
      liste: [],
    },
    // { lg: "Formations", route: "/training", liste: [{ id: "Microsoft Azure", route: "/training1" }, { id: "DevOps", route: "/training2" }] },
    { lg: 'Carrières', route: '/joinus', liste: [] },
    { lg: 'A propos', route: '/about', liste: [] },
    { lg: 'Contact', route: '/contact', liste: [] },
  ];

  nav2: any[] = [
    { lg: 'Home', route: '/homefr', liste: [] },
    { lg: 'Services', route: '/services', liste: [] },
    { lg: 'References', route: '/reference', liste: [] },
    {
      lg: 'Training',
      action: 'scroll',
      target: 'training-section',
      liste: [],
      // liste: [
      //   { id: 'Microsoft Azure', route: '/training1' },
      //   { id: 'DevOps', route: '/training2' },
      // ],
    },
    { lg: 'Careers', route: '/joinus', liste: [] },
    { lg: 'About', route: '/about', liste: [] },
    { lg: 'Contact', route: '/contact', liste: [] },
  ];

  constructor(private router: Router, private translate: TranslateService) {}

  isDropdownOpen = false;
  currentLanguage = 'FR'; // Initial language
  currentImage = 'assets/images/fr.svg'; // Initial image source
  dropdownImages = {
    FR: 'assets/images/fr.svg',
    EN: 'assets/images/en.svg',
  };

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  swapLanguage(language: string) {
    if (this.currentLanguage !== language) {
      this.currentLanguage = language;
      this.currentImage = this.dropdownImages[language];
    }
    this.toggleDropdown();

    this.lang = language;
    this.translate.use(this.lang);

    // Update navigation and footer based on selected language
    this.nav = this.lang === 'EN' ? this.nav2 : this.nav1;
    this.foot = this.lang === 'EN' ? false : true;

    // Save language preference to local storage
    localStorage.setItem('lang', this.lang);
  }

  ngOnInit() {
    // Get language from local storage or default to 'FR'
    const storedLang = localStorage.getItem('lang') || 'FR';
    this.lang = storedLang;
    this.translate.use(this.lang);

    // Set navigation based on language
    this.nav = this.lang === 'EN' ? this.nav2 : this.nav1;
    this.foot = this.lang === 'EN' ? false : true;
  }

  switchLanguage(event: any) {
    const selectedLang = event.target.value;
    this.lang = selectedLang;
    this.translate.use(this.lang);

    // Update navigation and footer based on selected language
    this.nav = this.lang === 'EN' ? this.nav2 : this.nav1;
    this.foot = this.lang === 'EN' ? false : true;

    // Save language preference to local storage
    localStorage.setItem('lang', this.lang);

    // Navigate to the appropriate route
    //this.router.navigate([this.lang === 'EN' ? '/homefr' : '/homefr']);
  }

  scrollToSection(targetId: string) {
    const element = document.getElementById(targetId);
    if (element) {
      // Calculate offset to account for fixed navbar
      const navbarHeight = 80; // Approximate navbar height
      const elementPosition = element.offsetTop - navbarHeight;

      // Use modern smooth scrolling
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  }

  handleNavigation(item: any) {
    if (item.action === 'scroll' && item.target) {
      // Check if we're currently on the homepage
      const currentRoute = this.router.url;

      if (currentRoute === '/homefr') {
        // We're already on the homepage, just scroll to the section
        this.scrollToSection(item.target);
      } else {
        // We're not on the homepage, navigate to homepage first
        this.router.navigate(['/homefr']).then(() => {
          // Wait a bit for the page to load, then scroll to the section
          setTimeout(() => {
            this.scrollToSection(item.target);
          }, 100);
        });
      }
    } else if (item.route) {
      this.router.navigate([item.route]);
    }
  }
}
